import { Typography } from "@mui/material";
import { RowJustifyStartFlex } from "../commons/Containers";
import LinkIcon from '@mui/icons-material/Link';
import PhoneIcon from '@mui/icons-material/Phone';
import ReplyIcon from '@mui/icons-material/Reply';
import TurnLeftIcon from '@mui/icons-material/TurnLeft';
import LaunchIcon from '@mui/icons-material/Launch';

export const AbstractButton = ({ type, Icon }) => {
    return (
        <RowJustifyStartFlex gap={1}>
            {Icon && <Icon />}
            <Typography variant="body2">
                {ButtonLabel[type]}
            </Typography>
        </RowJustifyStartFlex>
    );
};

export const ButtonLabel = {
    'url': 'Url',
    'phone_number': 'Phone',
    'quick_reply': 'Quick reply'
}

export const ButtonIcons = {
    'url': LaunchIcon,
    'phone_number': PhoneIcon,
    'quick_reply': TurnLeftIcon,
};

export const ButtonType = ({ row }) => {
    const icon = ButtonIcons[row.original.type];
    return <AbstractButton type={row.original.type} Icon={icon} />;
}

